module.exports = __webpack_public_path__ + "static/img/8.9ee5b97.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/6/zh/8.png
// module id = tUsE
// module chunks = 0